export default __webpack_public_path__ + "static/media/top-footer-image.28681187.png";